import React from "react";
import { CargarDatosPaginacion, BuscarPrestacionesPP } from "./action";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Drawer,
  Card, CardHeader, CardText, CircularProgress, RaisedButton
} from "material-ui";

import styles from "../../styles/styles";
import Editar from "material-ui/svg-icons/image/edit";
import Eliminar from "material-ui/svg-icons/action/delete";

// eslint-disable-next-line react/prefer-stateless-function
// eslint-disable-next-line react/no-multi-comp
class PaginacionSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      rowsPerPage: 5,
    };
  }

  componentWillMount() {
    //console.log("Component will mount");
    //console.log(this.props.totalPagina);
    this.props.dispatch(CargarDatosPaginacion(this.props.totalPagina));
    this.props.dispatch(BuscarPrestacionesPP(1, this.props.totalPagina));
  }

  BuscarPrestacionesPP = (valor, totalPagina) => {
    this.props.dispatch(BuscarPrestacionesPP(valor, totalPagina));
  }


  EditEnabled = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    let result = false;
    this.props.prestacionesPP.forEach((item) => {
      if (idPrestacion === item.IDPRESTACION && CodPrestacion === item.COD_PRESTADOR
        && (CodProf === item.PROF_CCOD || item.PROF_CCOD === "**") && (TipoAtencion === item.TIPO_ATENCION || typeof item.TIPO_ATENCION === "undefined")) {
        result = true;
      }
    });

    return result;
  }


  sendData = (i) => {
    this.props.parentCallback(i);
  }

  SetPaginacion = (pagenew, rowsPerPage) => {
    //console.log("NUMERO DE PAGINA");
    //console.log(pagenew)
    const idTableBodyc = this.props.idTableBody;
    const itemDesde = rowsPerPage * (pagenew - 1);
    const cantidad = rowsPerPage;
    const total = this.props.totalRows;

    if (document.getElementById(idTableBodyc)) {
      const menuListPrestaciones = [];
      const tableBodyRows = document.getElementById(idTableBodyc).querySelectorAll("tbody>tr");

      this.sendData(pagenew);


      for (let i = 0; i < total; i += 1) {
        let styleDisplay = "";
        if (i < itemDesde || i > (itemDesde + cantidad) - 1) {
          styleDisplay = "none";
        }
        if (tableBodyRows[i]) {
          tableBodyRows[i].style.display = styleDisplay;
        }
      }
      this.setState({ page: pagenew });
    }
  }

  render() {
    const itemsNumPages = [];
    let isInvisible = false;
    const cantPages = this.props.totalPage;

    const detalleArancel = this.props.detalleArancel;

    const menuListPrestaciones = [];

    this.props.prestacionesPP.map((row, index) => (
      menuListPrestaciones.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.contTablaReajuste1}>{row.CENTRO_AT}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste2}>{row.COD_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste3}>{row.GUARISMO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste4}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste5}>{row.COD_ISAPRE}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste6}>{row.TIPO_PRESTACION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste7}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste8}>{row.UNIDAD === "PE" ? "$" : null}{row.VALOR}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste9}>{row.TIPO_ATENCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste10}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste11}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
          <TableRowColumn style={styles.contTablaReajuste12}>{row.ITEM_IMED}</TableRowColumn>
        </TableRow>
      ))
    ));

    // if (detalleArancel) {
    //   detalleArancel.map((row, index) => (
    //     menuListPrestaciones.push((
    //       <TableRow key={index}>
    //         <TableRowColumn style={styles.contTablaReajuste1}>{row.CENTRO_AT}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste2}>{row.COD_PRESTADOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste3}>{row.GUARISMO}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste4}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste5}>{row.COD_ISAPRE}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste6}>{row.TIPO_PRESTACION}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste7}>{row.PROF_CCOD}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste8}>{row.UNIDAD === "PE" ? "$" : null}{row.VALOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste9}>{row.TIPO_ATENCION}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste10}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste11}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste12}>{row.ITEM_IMED}</TableRowColumn>
    //       </TableRow>
    //     ))
    //   ));
    // } else {
    //   this.props.prestacionesPP.map((row, index) => (
    //     menuListPrestaciones.push((
    //       <TableRow key={index}>
    //         <TableRowColumn style={styles.contTablaReajuste1}>{row.CENTRO_AT}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste2}>{row.COD_PRESTADOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste3}>{row.GUARISMO}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste4}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste5}>{row.COD_ISAPRE}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste6}>{row.TIPO_PRESTACION}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste7}>{row.PROF_CCOD}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste8}>{row.UNIDAD === "PE" ? "$" : null}{row.VALOR}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste9}>{row.TIPO_ATENCION}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste10}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste11}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
    //         <TableRowColumn style={styles.contTablaReajuste12}>{row.ITEM_IMED}</TableRowColumn>
    //       </TableRow>
    //     ))
    //   ));
    // }

    for (let i = 1; i <= cantPages; i += 1) {
      if ((cantPages - i > 3 || i > 3) &&
        i !== this.state.page && Math.abs(this.state.page - i) > 1 &&
        i > 2 && i < cantPages - 1) {
        if (!isInvisible) {
          itemsNumPages.push((
            <div key={`inviblebtn${i}`} style={{ width: 30, display: "inline-block" }}>.....</div>
          ));
        }
        isInvisible = true;
      } else {
        isInvisible = false;
        itemsNumPages.push((
          <RaisedButton
            key={`btn_pagination_${this.props.idTableBody}_${i}`}
            label={i}
            secondary
            labelStyle={this.props.labelStyleBtnPage}
            overlayStyle={this.props.overlayStyleBtnPage}
            rippleStyle={this.props.rippleStyleBtnPage}
            buttonStyle={this.props.buttonStyleBtnPage}
            style={this.props.styleBtnPage}
            disabled={i === this.state.page}
            onClick={() => { this.BuscarPrestacionesPP(i, this.props.totalPagina); this.SetPaginacion(i); }}
          />
        ));
      }
    }


    return (
      <div>
        {this.props.pageSize === 0 ?
          null :
          <div style={{ textAlign: "center", margin: "10px 0px" }}>
            <div style={{ overflow: "auto" }}>
              <div style={{ width: "1700px", textAlign: "left" }}>
                <Table
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaReajuste1} >Centro de Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste2} >Código<br />Prestación Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste3} >Guarismo de DP o<br />Sala de Procedimiento</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste4} >Glosa<br />Prestación Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste5} >Código<br />Fonasa / Isapre</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste6} >Tipo de Prestación Isapre</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste7} >Código<br />Profesional Isapre</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste8} >Valor</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste9} >Tipo<br />de Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste10} >Unidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste11} >Fecha de<br />Vigencia de precio</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaReajuste12} >Item IMED</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyBusquedaPrestacionesSE"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListPrestaciones}
                  </TableBody>
                </Table>

              </div>
            </div>
            {itemsNumPages}

            <hr />
          </div>
        }
      </div>
    );
  }
}

PaginacionSE.defaultProps = {
  pageDefault: 1,
  rowsPerPageDefault: 10,
  showRowsPerPage: true,

  labelStyleBtnPage: null,
  overlayStyleBtnPage: null,
  rippleStyleBtnPage: null,
  styleBtnPage: null,
  buttonStyleBtnPage: null,

  styleRowsPerPage: null,
  labelStyleRowsPerPage: null,
  underlineStyleRowsPerPage: null,
  iconStyleRowsPerPage: null,
  menuItemStyleRowsPerPage: null,
  selectedMenuItemStyleRowsPerPage: null,
};

PaginacionSE.propTypes = {
  pageSize: PropTypes.number.isRequired,
  totalPage: PropTypes.number,
  totalRows: PropTypes.number.isRequired,
  pageDefault: PropTypes.number,
  rowsPerPageDefault: PropTypes.number,
  idTableBody: PropTypes.string.isRequired,
  showRowsPerPage: PropTypes.bool,

  labelStyleBtnPage: PropTypes.any,
  overlayStyleBtnPage: PropTypes.any,
  rippleStyleBtnPage: PropTypes.any,
  styleBtnPage: PropTypes.any,
  buttonStyleBtnPage: PropTypes.any,

  styleRowsPerPage: PropTypes.any,
  labelStyleRowsPerPage: PropTypes.any,
  underlineStyleRowsPerPage: PropTypes.any,
  iconStyleRowsPerPage: PropTypes.any,
  menuItemStyleRowsPerPage: PropTypes.any,
  selectedMenuItemStyleRowsPerPage: PropTypes.any,
  parentCallback: PropTypes.any,
  prestacionesPP: PropTypes.array.isRequired,
  tipoArancel: PropTypes.number.isRequired,
  rutInstitucion: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  tablaBusquedaPrestaciones: PropTypes.string,
  tablaBody: PropTypes.string,
  totalPagina: PropTypes.number,

};

const mapStateToProps = (state) => ({
  pageSize: state.paginacionState.pageSize,
  totalPage: state.paginacionState.totalPage,
  prestacionesPP: state.paginacionState.prestacionesPP,
  tipoArancel: state.global.filtros_CAT.tipoArancel || 0,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaginacionSE);



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/PaginacionSE/view.jsx